<template>
  <v-sheet outlined class="px-2 px-md-7">
    <v-container class="my-8">
      <v-row class="w--100">
        <v-col cols="12" md="8">
          <span class="mb-2 fieldset-title"
            >دسته بندی کالای مورد نظر را ثبت کنید.</span
          >
        </v-col>
      </v-row>
      <template v-if="activeSelectedItem && activeSelectedItem.activeTreeItem">
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              label="جستجو"
              outlined
              dense
              type="text"
              required
              v-model="searchTreeList"
              append-icon="mdi-magnify"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card outlined>
              <v-card-title>
                <span class="blue--text text--darken-5">{{
                  activeSelectedItem.item.displayName
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-treeview
                  :ref="`treeView${activeSelectedItem.item.title}`"
                  item-text="name"
                  item-key="id"
                  item-children="subcategories"
                  :items="activeSelectedItem.treeList"
                  :search="searchTreeList"
                  color="primary"
                  transition
                  :open.sync="activeSelectedItem.openTreeItem"
                  return-object
                >
                  <template v-slot:label="props">
                    <div class="treeCheckBox">
                      <v-checkbox
                        v-if="props.item.isLeaf"
                        v-model="activeSelectedItem.activeTreeItem"
                        class="mt-0"
                        hide-details
                        :value="props.item"
                        :label="props.item.name"
                        small
                        dense
                        :ripple="false"
                        @change="selectTree"
                      >
                      </v-checkbox>
                      <span v-else class="f-s-13 text-right">{{
                        props.item.name
                      }}</span>
                    </div>
                  </template>
                </v-treeview>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <v-row ref="tables" class="mt-5" v-if="merchantCategoriesList.length">
        <v-col cols="12">
          <!-- $store.getters.tradeRequestIsEdit && -->
          <MerchantCategoryComponentVue
            v-if="
              merchantCategoryTypes == 'IndustrialService' &&
              $store.getters.tradeRequestEditMode
            "
            @changeProcessType="changeProcessType"
            :items="merchantCategoriesList"
            :merchantCategoryTypes="merchantCategoryTypes"
            :fields="merchantCategoryFieldsIndustrialService"
            @removeFromList="removeMerchantCategoriesList"
          />
          <!-- !$store.getters.tradeRequestIsEdit && -->
          <MerchantCategoryComponentVue
            v-if="
              merchantCategoryTypes == 'ConsultingService' ||
              merchantCategoryTypes == 'ElectronicDocument' ||
              (merchantCategoryTypes == 'IndustrialService' &&
                
                !$store.getters.tradeRequestEditMode)
            "
            @changeProcessType="changeProcessType"
            :items="merchantCategoriesList"
            :merchantCategoryTypes="merchantCategoryTypes"
            :fields="
              merchantCategoryTypes == 'IndustrialService'
                ? merchantCategoryFieldsIndustrialService
                : merchantCategoryFields
            "
            @removeFromList="removeMerchantCategoriesList"
          />
          <supplier-product-properties
            v-else-if="merchantCategoryTypes == 'Product'"
            :isSelectedProduct="isSelectedProduct"
            :selectedForEdit="selectedForEdit"
            :measurementFlag="measurementFlag"
            :breadCrumb="breadCrumb"
            :properties="selectedProduct.properties"
            @completeProductProperties="completeProductProperties"
          >
          </supplier-product-properties>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const categoryRepository = () => RepoFactory.get('category');
const supplierProductRepository = () => RepoFactory.get('supplierProduct');
const measurementQuantitiesRepository = () =>
  RepoFactory.get('measurementQuantities');
import MerchantCategoryComponentVue from './MerchantCategoryComponent.vue';
import SupplierProductProperties from './SupplierProductProperties.vue';

export default {
  props: {
    resetTree: {
      type: Boolean,
      default: false,
    },
    closeStepper: {
      type: Boolean,
    },
    techInfos: {
      type: Array,
      default: [],
    },
    itemTitle:{
       type: String,
      default: '',
    }
  },

  components: {
    MerchantCategoryComponentVue,
    SupplierProductProperties,
  },
  data() {
    return {
      breadCrumb:'',
      tableEditItems: [],
      SaveBtn: false,
      measurementFlag: false,
      selectedForEdit: [],
      categoryIds: [],
      processType: [],
      product: {},
      selectedProduct: {
        productId: null,
        categoryId: null,
        name: null,
        summary: null,
        description: null,
        imagesFileIds: [],
        properties: [],
        countingUnit: null,
        taxed: false,
      },
      isSelectedProduct: false,
      editFlag: false,
      merchantCategoryTypes: [],
      merchantCategoriesList: [],
      merchantCategoryFieldsIndustrialService: [
        {
          value: 'breadcrumb',
          text: 'عنوان فرایند ',
          sortable: false,
        },

        {
          value: 'productionProcessType',
          text: 'نوع فرایند ',
        },
        {
          value: 'actions',
          text: 'عملیات',
          sortable: false,
        },
      ],
      merchantCategoryFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'عملیات',
          sortable: false,
        },
      ],
      actvieList: [],
      activeSelectedItem: null,
      searchTreeList: null,
      selectionItems: [],
      activeTreeItem: [],
      form: {
        categoryIds: null,
        categoryTypes: [],
      },
    };
  },
  computed: {
    checkIfSelectedTreeNode() {
      return (
        this.selectionItems.length &&
        this.selectionItems.find((el) => el.activeTreeItem.length)
      );
    },
    closeStepperProp: {
      get() {
        return this.closeStepper;
      },
      set(val) {
        this.$emit('changeCloseStepper', val);
      },
    },
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
  },
  methods: {
    completeProductProperties(product) {
      this.product.properties = [];
      this.product.properties = product.properties;
      // this.product.properties = properties;

      this.$emit(
        'getTradeRequestItemPropertyValues',
        this.product.properties,
        this.form.categoryIds
      );
      this.SaveBtn = true;
    },
    async selectProductForAddingNewSupplierProduct(categoryId) {
      let app = this
      const loader = this.$loading.show();
       await supplierProductRepository()
        .getProductAllProperties(
          categoryId,
          app.productBaseUrl
        )
        .then((response) => {
          let tempProductProperties = [];
          
          response.data.forEach((element) => {
            element.propertyId = element && element.id ? element.id : '';
            element.measurementUnitId = element.defaultMeasurementUnitId;
            element.measurementUnitItem = [];
            if (element.measurementQuantityId) {
               
                  // element.measurementUnitItem = element.units;
                     measurementQuantitiesRepository()
                .getMeasurementQuantityActiveUnits(element.measurementQuantityId, app.productBaseUrl,{})
                .then(res => {
                   
                  element.measurementUnitItem = res.data;
                  tempProductProperties.push(element);
                   
                })
                .catch(error => {
                   
                  Helper.handleErrors(error, this)
                })
                .finally(()=>{
                   
                })
                
            } else {
               
              tempProductProperties.push(element);
            }
             
            if (
              this.$store.getters.tradeRequestEditMode &&
              this.$store.getters.tradeRequestSingleItemForEdit.techInfos[0]
            ) {
               
              this.$store.getters.tradeRequestSingleItemForEdit.techInfos[0].tradeRequestItemPropertyValues.forEach(
                (selectedProperty) => {
                  if (selectedProperty.propertyId == element.id) {
                    element.id = selectedProperty.id;
                    element.value =
                      element.propertyType == 'MultiSelectList'
                        ? selectedProperty.value.split('|')
                        : selectedProperty.value;
                    element.measurementUnitId =
                      selectedProperty.measurementUnitId;
                      element.maxValue= selectedProperty.maxValue
                      element.setMaxValue= selectedProperty.maxValue? true: false
                  }
                }
              );
            }
          });
          setTimeout(() => {
          this.selectedProduct.properties = tempProductProperties;
          }, 1000);
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },

     selectProductForAddingNewSupplierProductOld(categoryId) {
      const loader = this.$loading.show();
        supplierProductRepository()
        .getProductAllProperties(categoryId, this.productBaseUrl)
        .then((response) => {
          let tempProductProperties = [];

          response.data.forEach((element) => {
            element.propertyId = element && element.id ? element.id : '';
            element.measurementUnitItem = [];
            if (element.measurementQuantityId) {
              measurementQuantitiesRepository()
                .getMeasurementQuantityActiveUnits(
                  element.measurementQuantityId,
                  this.productBaseUrl
                )
                .then((res) => {
                  element.measurementUnitItem = res.data;
                  tempProductProperties.push(element);
                  this.measurementFlag = true;
                  loader.hide()
                })
                .catch((error) => {
                  loader.hide();
                  Helper.handleErrors(error, this);
                });
            } else {
              tempProductProperties.push(element);
            }
            if (
              this.$store.getters.tradeRequestIsEdit &&
              this.$store.getters.tradeRequestSingleItemForEdit &&
              this.$store.getters.tradeRequestSingleItemForEdit.techInfos[0]
                .tradeRequestItemPropertyValues.length
            ) {
              this.$store.getters.tradeRequestSingleItemForEdit.techInfos[0].tradeRequestItemPropertyValues.forEach(
                (selectedProperty) => {
                  if (selectedProperty.categoryPropertyId == element.id) {
                    element.id = selectedProperty.id;
                    element.propertyId = selectedProperty.categoryPropertyId;
                    element.measurementUnitId =
                      selectedProperty.measurementUnitId;
                  }
                }
              );
            }
          });
           setTimeout(() => {
          this.selectedProduct.properties = tempProductProperties;
          }, 1000);

          if (this.$store.getters.tradeRequestEditMode) {
          }
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    changeProcessType(item, items) {
      this.$emit('getCategoriesList', items);
    },
    selectedActivitiesTypes() {
      if (this.form.categoryTypes.length) {
        return this.actvieList.filter((el) =>
          this.form.categoryTypes.includes(el.title)
        );
      } else {
        return [];
      }
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('CategoryTypeItems', this.$store.getters.productBaseUrl)
          .then(({ data }) => {
            this.actvieList = data;
            resolve();
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          });
      });
    },
    getCategoriesTreeList(val) {
      const loader = this.$loading.show();
      const param = {};
      param.categoryTypes = val;
      categoryRepository()
        .getCategoriesList(this.$store.getters.productBaseUrl, param)
        .then((res) => {
          const data = {
            item: val,
            treeList: res.data,
            activeTreeItem: [],
            openTreeItem: res.data,
          };
          this.$set(this.selectionItems, this.selectionItems.length, data);
          this.activeSelectedItem = data;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    async getMerchantCategoriesByIds() {
      let app = this
      let ids = [];
      if (this.editFlag) {
        this.form.categoryIds = [];
        this.form.categoryIds = this.categoryIds;
        /////------------------last change ----------------/////
        if (this.activeSelectedItem && this.activeSelectedItem.activeTreeItem) {
          ids = this.activeSelectedItem.activeTreeItem.map((el) => {
            return el.id;
          });
        }
        ids.forEach(id=>{
          this.form.categoryIds.push(id)
        })
      } 
      else {
        if (this.activeSelectedItem && this.activeSelectedItem.activeTreeItem) {
          ids = this.activeSelectedItem.activeTreeItem.map((el) => {
            return el.id;
          });
        }
        //  
        if (
          this.form.categoryIds == undefined ||
          this.form.categoryIds == null
        ) {
          this.form.categoryIds = [];
        }
        this.form.categoryIds = ids;
      }

      if (
        this.merchantCategoryTypes != 'IndustrialService' &&
        typeof this.merchantCategoryTypes == 'string'
      ) {
        this.form.categoryIds = [
          this.form.categoryIds[this.form.categoryIds.length - 1],
        ];
      }
      if (this.merchantCategoryTypes == 'Product') {
        this.selectProductForAddingNewSupplierProduct(this.form.categoryIds[0]);
      }
      const params = {
        ids: this.form.categoryIds.join(','),
      };
      const loader = this.$loading.show()
      await categoryRepository()
        .getMerchantCategoriesByIds(this.$store.getters.productBaseUrl, params)
        .then((res) => {
          this.merchantCategoriesList = res.data;
          if (this.merchantCategoryTypes == 'IndustrialService') {

          }
          
          app.breadCrumb = res.data[0].breadcrumb
          
          this.activeSelectedItem.activeTreeItem.forEach((el) => {
            if (!this.form.categoryTypes.includes(el.categoryType)) {
              this.form.categoryTypes.push(el.categoryType);
            }
          });
          loader.hide()
        })
        .catch(err=>{
            Helper.handleErrors(err, this);
            loader.hide()
        })
    },
    selectTree(val) {
      if (this.merchantCategoryTypes != 'IndustrialService') {
        this.activeSelectedItem.activeTreeItem = [
          this.activeSelectedItem.activeTreeItem[
            this.activeSelectedItem.activeTreeItem.length - 1
          ],
        ];
      }
      if (val && val.length) {
        this.getMerchantCategoriesByIds();
      } else {
        this.merchantCategoriesList = [];
        this.form.categoryIds = [];
      }
    },
    deSelectTree() {
      this.selectionItems.forEach((element) => {
        element.activeTreeItem = [];
      });
    },
    removeMerchantCategoriesList(item) {
      // step:1 remove from merchant categories list
      this.merchantCategoriesList = this.merchantCategoriesList.filter(
        (el) => el.categoryId !== item.categoryId
      );
      this.form.categoryIds = this.form.categoryIds.filter(
        (el) => el !== item.categoryId
      );
      // step:2 remove from selected tree items
      this.activeSelectedItem.activeTreeItem =
        this.activeSelectedItem.activeTreeItem.filter(
          (el) => el.id != item.categoryId
        );
      // step:3 remove from categoryTypes if removed merchant
      // category is not exist in categoryTypes
      const categoryTypeTitle = item.categoryTypeTitle;
      if (
        !this.merchantCategoriesList.find(
          (el) => el.categoryTypeTitle == categoryTypeTitle
        )
      ) {
        this.form.categoryTypes.splice(
          this.form.categoryTypes.indexOf(categoryTypeTitle),
          1
        );
        this.merchantCategoryTypes.splice(
          this.form.categoryTypes.indexOf(
            (el) => el.title == categoryTypeTitle
          ),
          1
        );
      }
    },
    setMerchantCategoryTypes() {
      let app = this;
      this.getCategoryTypeItems();
      this.merchantCategoriesList = [];
      this.merchantCategoryTypes = this.$store.getters.tradeRequestCategoryType;
      this.getCategoriesTreeList(this.merchantCategoryTypes);
      this.merchantCategoriesList = [];
      this.activeSelectedItem && this.activeSelectedItem.activeTreeItem
        ? (this.activeSelectedItem.activeTreeItem = [])
        : '';
      app.closeStepperProp = false;
    },
  },

  watch: {
    itemTitle(after, before){
      if(after.length >0){
        this.searchTreeList = after
      }
    },
    async techInfos() {
      let app = this
      if (
        app.techInfos &&
        app.techInfos.length &&
        this.$store.getters.tradeRequestEditMode
      ) {
        if (app.merchantCategoryTypes != 'Product') {
          app.editFlag = true;
          let ids = [];
          app.techInfos.forEach((x) => {
            
            ids.push(x.productCategoryId);
            app.processType.push(x.processType);

          });
          
          app.categoryIds = ids;
          await app.getMerchantCategoriesByIds();
           
          if( app.merchantCategoriesList && app.merchantCategoriesList.length){
            
            app.merchantCategoriesList.forEach((item,i)=>{
            item.productionProcessType = app.processType[i]
          })
           }
          
         
         if (app.merchantCategoryTypes != 'IndustrialService') {
           app.getMerchantCategoriesByIds();
         }

        } 
        else if (app.merchantCategoryTypes == 'Product' && !app.SaveBtn) {
          app.editFlag = true;
          app.selectedForEdit = [];
          app.categoryIds.push(app.techInfos[0].productCategoryId);
          app.getMerchantCategoriesByIds();
          setTimeout(() => {
             app.selectedForEdit = app.techInfos[0].tradeRequestItemPropertyValues;
          app.isSelectedProduct = true;
          }, 1000);
         
        }
      }
    },
    '$store.getters.tradeRequestEditMode': function () {
      this.merchantCategoryTypes = this.$store.getters.tradeRequestCategoryType;
      this.getCategoriesTreeList(this.merchantCategoryTypes);
    },
    '$store.getters.tradeRequestCategoryType': function () {
      if (
        this.$store.getters.tradeRequestCategoryType &&
        this.$store.getters.tradeRequestCategoryType.length
      ) {
        this.getCategoryTypeItems();
        this.merchantCategoriesList = [];
        this.merchantCategoryTypes =
          this.$store.getters.tradeRequestCategoryType;
        this.getCategoriesTreeList(this.merchantCategoryTypes);
      }
    },
    resetTree() {
      if (this.resetTree) {
        this.SaveBtn = false;
        this.measurementFlag = false;
        this.categoryIds = [];
        this.processType = [];
        this.selectedForEdit = [];
        this.product = {};
        this.selectedProduct = {
          productId: null,
          categoryId: null,
          name: null,
          summary: null,
          description: null,
          imagesFileIds: [],
          properties: [],
          countingUnit: null,
          taxed: false,
        };
        this.isSelectedProduct = false;
        this.editFlag = false;
        this.merchantCategoryTypes = [];
        this.merchantCategoriesList = [];
        (this.merchantCategoryFields = [
          {
            value: 'mainCategoryTitle',
            text: 'نوع فعالیت',
            sortable: false,
          },
          {
            value: 'breadcrumb',
            text: 'فرایند اصلی',
            sortable: false,
          },

          {
            value: 'actions',
            text: 'عملیات',
            sortable: false,
          },
        ]),
          (this.actvieList = []);
        this.activeSelectedItem = [];
        this.searchTreeList = null;
        this.selectionItems = [];
        this.activeTreeItem = [];
        this.form = {
          categoryIds: null,
          categoryTypes: [],
        };
        this.setMerchantCategoryTypes();
        this.closeStepperProp = false;
      }
    },
    merchantCategoriesList() {
      if (this.merchantCategoryTypes != 'Product') {
        this.$emit('getCategoriesList', this.merchantCategoriesList);
      }
    },
  },
  created() {
    this.getCategoryTypeItems();
    if (
      this.$store.getters.tradeRequestCategoryType &&
      this.$store.getters.tradeRequestCategoryType.length
    ) {

      this.merchantCategoryTypes = this.$store.getters.tradeRequestCategoryType;
      this.getCategoriesTreeList(this.merchantCategoryTypes);
    }
  },
};
</script>

<style></style>
